import React, { Fragment } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "../../components/Common/withRouter";
import Breadcrumb from "../../components/Common/Breadcrumb";
import i18n from "../../i18n";
import { orgId } from "../../constants/utils";
import defaultImage from "../../assets/images/default-profile.png";

const UserProfile = (props) => {
  document.title = `${i18n.t("Profile")} - ${orgId}`;

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      data: Login.data
    })
  );

  const { data } = useSelector(LoginProperties);
  const profileData = data?.data || {};
  const full_name = profileData.full_name || "";
  const email = profileData.email || "";
  const sub = profileData.id || "";
  const picture = profileData.picture || defaultImage;

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="" breadcrumbItem={i18n.t("Profile")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={picture}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center mx-1">
                      <div className="text-muted">
                        <h5>{full_name}</h5>
                        <p className="mb-1">Email: {email}</p>
                        <p className="mb-0">ID: {sub}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default withRouter(UserProfile);
